import { Tabs } from "antd";
import { css, styled } from "styled-components";
import { AppCard } from "../..";

export const StyledAppsContainerSidebarMenuContainer = styled(AppCard)<{
  collapsed: boolean;
  minWidth?: string;
  maxWidth?: string;
}>`
  width: ${({ collapsed, minWidth, maxWidth }) =>
    collapsed ? minWidth || "70px" : maxWidth || "100%"};
  max-width: ${({ collapsed, minWidth, maxWidth }) =>
    collapsed ? minWidth || "70px" : maxWidth || "100%"};

  .ant-card-head {
    background-color: ${({ theme }) => theme.palette.background.secondary};
    ${({ collapsed }) =>
      collapsed &&
      css`
        padding: 0;
        text-align: center;
      `}
  }
`;

export const StyledAppsContainerSidebarMenu = styled(Tabs)<{
  collapsed: boolean;
  minWidth?: string;
  maxWidth?: string;
}>`
  transition: all 0.5s ease;
  width: ${({ collapsed, minWidth, maxWidth }) =>
    collapsed ? minWidth || "70px" : maxWidth || "100%"};
  max-width: ${({ collapsed, minWidth, maxWidth }) =>
    collapsed ? minWidth || "70px" : maxWidth || "100%"};

  .ant-tabs-content-holder {
    display: none;
  }

  .ant-tabs-nav {
    width: 100%;
    background-color: ${({ theme }) => theme.palette.background.paper};
    border-radius: ${({ theme }) => theme.cardRadius};
    border: 1px dashed ${({ theme }) => theme.palette.borderColor};

    .ant-tabs-nav-wrap {
      .ant-tabs-nav-list {
        .ant-tabs-tab {
          margin: 0;
          transition: all 0.3s ease;
          border-radius: ${({ theme }) => theme.cardRadius};
          overflow: hidden;

          &.ant-tabs-tab-active {
            background-color: ${({ theme }) =>
              theme.palette.background.secondary};

            .ant-tabs-tab-btn {
              span {
                color: ${({ theme }) => theme.palette.text.secondary};
              }
            }
          }

          .ant-tabs-tab-btn {
            align-items: center;
            justify-content: center;
            gap: 10px;
            color: ${({ theme }) => theme.palette.text.secondary}!important;

            .ant-typography {
              ${({ collapsed }) =>
                collapsed &&
                css`
                  display: none;
                `}
              font-size: 14px;
              line-height: 1;
              padding: 0;
              color: inherit !important;
            }

            .ant-tabs-tab-icon {
              display: inline-block;
              font-size: 14px !important;
              line-height: 1;
              padding: 0;
              color: inherit !important;
            }
          }
        }
      }
    }
  }
`;
